"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _HBClickable = _interopRequireDefault(require("../HBClickable/HBClickable"));
var _HBText = _interopRequireDefault(require("../HBText/HBText"));
var DrawerOptionsListItem = function DrawerOptionsListItem(_ref) {
  var closeDrawer = _ref.closeDrawer,
    _ref$closeDrawerOnCli = _ref.closeDrawerOnClick,
    closeDrawerOnClick = _ref$closeDrawerOnCli === void 0 ? true : _ref$closeDrawerOnCli,
    Icon = _ref.icon,
    onClick = _ref.onClick,
    subtitle = _ref.subtitle,
    testIdName = _ref.testIdName,
    title = _ref.title,
    _ref$titleColor = _ref.titleColor,
    titleColor = _ref$titleColor === void 0 ? 'textPrimary' : _ref$titleColor;
  var handleClick = function handleClick() {
    if (closeDrawerOnClick) {
      closeDrawer();
    }
    onClick();
  };
  return /*#__PURE__*/_react["default"].createElement(GridContainer, {
    onClick: handleClick,
    testIdName: testIdName
  }, Icon, typeof title === 'string' ? /*#__PURE__*/_react["default"].createElement(Title, {
    color: titleColor
  }, title) : title, subtitle && /*#__PURE__*/_react["default"].createElement(Subtitle, null, subtitle));
};
var _default = exports["default"] = DrawerOptionsListItem; // -------------------------------- Styles -------------------------------- //
var GridContainer = (0, _styledComponents["default"])(_HBClickable["default"]).withConfig({
  displayName: "DrawerOptionsListItem__GridContainer",
  componentId: "sc-8srbke-0"
})(["display:grid;grid-template-columns:auto 1fr;grid-column-gap:12px;padding:16px 0;align-items:center;"]);
var Title = (0, _styledComponents["default"])(_HBText["default"]).attrs({
  type: 'body18'
}).withConfig({
  displayName: "DrawerOptionsListItem__Title",
  componentId: "sc-8srbke-1"
})([""]);
var Subtitle = (0, _styledComponents["default"])(_HBText["default"]).attrs({
  type: 'body14',
  color: 'textSecondary'
}).withConfig({
  displayName: "DrawerOptionsListItem__Subtitle",
  componentId: "sc-8srbke-2"
})(["grid-column:2;"]);
//# sourceMappingURL=DrawerOptionsListItem.js.map